import { Component, Input } from '@angular/core'; 
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { ReviewService } from 'src/app/services/common/review.service';
import {  serviceConstants } from 'src/app/constants/service.constants';
@Component({
  selector: 'app-references-documents',
  templateUrl: './references-documents.component.html',
  styleUrls: ['./references-documents.component.scss']
})
export class ReferencesDocumentsComponent {

  selectedDocs: any[]=[]; 
  @Input() public Content: any;
  content: any;  
  ReviewId: any;   

  
  constructor(
    private reviewService: ReviewService,
    private commonService: CommonService, 
    public modalRef: NgbActiveModal 
    ){}
  
  ngOnInit(){
    if (this.Content.content !== null) {   
      if(this.Content.content.ReviewId!=null && this.Content.content.ReviewId!="" && this.Content.content.ReviewId!=undefined)
       {
           this.ReviewId = this.Content.content.ReviewId;
           this.GetReferenceDocments();
       }
      }
  }

  GetReferenceDocments() {
   
    this.reviewService.GetReferenceDocuments("api/Review/ReviewReferenceDocments?Id=" + this.ReviewId).subscribe((result: any[] )=> {
      if (result) { 
       this.selectedDocs=[];
       this.selectedDocs=result["lstRevDocuments"];     
      }
    });
  }
 
  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/Review/DownloadFileByDocId?ReviewDocId=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName, Type) {
    this.commonService.previewFile(fileID, fileName, "review");
  }
  close(){ 
    this.modalRef.dismiss();
   }
}
